import React, { useMemo, useState } from "react";
import styled from "styled-components";

import { extractByTag } from "@examspark/common";
import { DisplayName, useQueryGetUnitVocabulary } from "@examspark/common-app";
import { Text, VSpace } from "@examspark/common-ui";
import { ParsedTCMPCUnit, VocabularyItem } from "@examspark/types";

import VocabularyDetailModal from "../../vocabulary/VocabularyDetailModal";

export const VocabularyList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
export const Vocabulary = styled.button`
  display: flex;
  align-items: center;
  border: solid 1px #ddd;
  padding: 0.7rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  background-color: #fff;
  gap: 0.5rem;
  color: #444;

  &:hover {
    border: solid 1px #bbb;
  }
`;

function extractVocabularies(
  vocabularies: ParsedTCMPCUnit["vocabularies"],
  section: string,
) {
  return extractByTag(vocabularies, "tcmpc-usage", section);
}

const UnitSummaryVocabulary = (props: { unit: ParsedTCMPCUnit }) => {
  const [showVocabularyList, setShowVocabularyList] =
    useState<VocabularyItem[]>();
  const [showVocabularyIndex, setShowVocabularyIndex] = useState<number>();
  const vocabulariesQuery = useQueryGetUnitVocabulary(props.unit);

  const localeSort = (a: VocabularyItem, b: VocabularyItem) =>
    a.vocabulary?.name
      ?.toLocaleLowerCase()
      .localeCompare(b.vocabulary?.name?.toLocaleLowerCase() ?? "") ?? 0;

  const primaryVocabulary = useMemo(
    () =>
      extractVocabularies(vocabulariesQuery.data, "primary").sort(localeSort),
    [vocabulariesQuery.data],
  );
  const relatedVocabulary = useMemo(
    () =>
      extractVocabularies(vocabulariesQuery.data, "related").sort(localeSort),
    [vocabulariesQuery.data],
  );

  return (
    <>
      <VocabularyDetailModal
        vocabularyList={showVocabularyList ?? []}
        showIndex={showVocabularyIndex}
        onShowIndexChange={(idx) => {
          setShowVocabularyIndex(idx);
        }}
      />
      <VSpace>
        <Text.H3>Unit / Module Vocabulary</Text.H3>
        <Text.H4>Content Vocabulary</Text.H4>
        <VocabularyList>
          {primaryVocabulary?.map((v, idx) => {
            return (
              <Vocabulary
                key={`${v.vocabulary?.id}${idx}`}
                onClick={() => {
                  setShowVocabularyList(primaryVocabulary);
                  setShowVocabularyIndex(idx);
                }}
              >
                <DisplayName resource={v.vocabulary} />
              </Vocabulary>
            );
          })}
        </VocabularyList>
        <Text.H4>Related Vocabulary</Text.H4>
        <VocabularyList>
          {relatedVocabulary?.map((v, idx) => {
            return (
              <Vocabulary
                key={`${v.vocabulary?.id}${idx}`}
                onClick={() => {
                  setShowVocabularyList(relatedVocabulary);
                  setShowVocabularyIndex(idx);
                }}
              >
                <DisplayName resource={v.vocabulary} />
              </Vocabulary>
            );
          })}
        </VocabularyList>
      </VSpace>
    </>
  );
};

export default UnitSummaryVocabulary;
